var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"masker"},[_c('button',{staticClass:"view-more",on:{"click":_vm.handleViewMoreClick}},[_c('i',{staticClass:"el-icon-arrow-down"}),_vm._v(" 查看更多 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }